import { MesureStation } from './mesure-station';
import { Substrat } from './substrat';
import { GPSPosition } from '../GPS-position';
import { LocalisationStation } from '../Shared/localisation-station';

export class IBGNProcess {
    id: number;
    interventionId: number;

    Code: string;
    TracabiliteCode: string;
    MesureStation: MesureStation = new MesureStation();
    Substrats: Substrat[] = [];
    LocalisationStation: LocalisationStation = new LocalisationStation();

    static mapFromJSON(json): IBGNProcess {
        const i = new IBGNProcess();

        i.Code = json.code;
        i.TracabiliteCode = json.tracabilite;

        if (json.mesureStation) {
            i.MesureStation = MesureStation.mapFromJSON(json.mesureStation);
        }

        if (json.localisationStation) {
            i.LocalisationStation = LocalisationStation.mapFromJSON(json.localisationStation);
        }

        return i;
    }
}
